export function getSessionStorage(key) {
  return JSON.parse(sessionStorage.getItem(key) || "null")
}

export function setSessionStorage(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

